// JointHolder/index.js
import React, { useEffect, useState } from 'react';
import { Nav, ProgressBar } from 'react-bootstrap';
import Button from "designs/v1/components/Button";
import PAN from './PAN';
import AddressVerification from './AddressVerification';
import ScannedSignature from './ScannedSignature';
import VisualVerification from './VisualVerification';
import Review from './Review';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { updateJointholderFlowScreen, getStageScreen } from '../../../../redux';
import axios from 'axios';
import ConsentModal from './components/ConsentModal';
import CorrespondanceAddress from './CorrespondanceAddress';
import { useHistory } from "react-router-dom";

function JointHolder() {
    const dispatch = useDispatch()
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);
    const [activeHolder, setActiveHolder] = useState(2)
    const [showAddMoreModal, setShowAdddMoreModal] = useState(false);
    const [showConsentModal, setShowConsentModal] = useState(false);
    const [showHolder, setShowHolder] = useState(2)
    const steps = [
        { name: 'PAN', component: <PAN activeHolder={activeHolder} />, showBackButton: false },
        { name: 'Address Verification', component: <AddressVerification activeHolder={activeHolder} />, showBackButton: true },
        { name: 'Scanned Signature', component: <ScannedSignature activeHolder={activeHolder} />, showBackButton: true },
        { name: 'Visual Verification', component: <VisualVerification activeHolder={activeHolder} />, showBackButton: true },
        { name: 'Correspondance Address Verification', component: <CorrespondanceAddress activeHolder={activeHolder} />, showBackButton: true },
    ];

    const handleNext = () => {
        setActiveStep((prevActiveStep) => Math.min(prevActiveStep + 1, steps.length - 1));
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
    };

    const getActiveStage = (data) => {
        console.log(data)
        if (!data.pan.status) {
            if (data.pan.pan_number_verified) {
                return 1 // Address
            } else {
                return 0 //PAN
            }
        }
        if (!data.address.status) {
            return 1 //Address
        }
        if (!data.cor_address.status) {
            return 4;
        }
        if (!data.signature_upload?.status) {
            return 2 // Signature
        }
        if (!data.visual_verification_confirmation.status) {
            return 3 // Visual Verification
        }
        return -1
    }


    const submitToApi = async (value, holder = 2) => {
        const portal_domain = window.sessionStorage.getItem("portal_domain");
        const API_URL = portal_domain
            ? portal_domain.substring(0, portal_domain.length - 1)
            : "";
        const token = window.sessionStorage.getItem("token");
        const headers = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                Authorization: `Basic ${token}`,
            },
        };
        let formData = new FormData();
        formData.append('confirmation', value);
        formData.append('holder', holder);
        try {
            const resp = await axios.post(
                `${API_URL}/api/method/kyc_customizations.apis.joint_holder.joint_holder_confirmation.endpoint`,
                formData,
                headers
            );

        } catch (error) {
            console.log(error)
        }
    }

    let stages = useSelector(state => state.navigation.stagesData)
    const getStages = () => {
        if (stages) {
            const { secound_holder, thrid_holder } = stages;
            let activeStage = getActiveStage(secound_holder);
            if (activeStage != -1) {
                setActiveHolder(2)
                setActiveStep(activeStage)
            } else {
                let activeStageThird = getActiveStage(thrid_holder);
                if (thrid_holder.consent != 1) {
                    if (activeStageThird == 0) {
                        setShowAdddMoreModal(true)
                    }
                }
                if (activeStageThird != -1) {
                    setActiveHolder(3)
                    setActiveStep(activeStageThird)
                } else {
                    setShowConsentModal(true);
                    // dispatch(updateJointholderFlowScreen(false))
                }
            }
        }
    }

    useEffect(() => {
        getStages()
    }, [stages])


    const handleCloseConsentModal = () => {
        setShowConsentModal(false);
        dispatch(updateJointholderFlowScreen(false));

        dispatch(getStageScreen());
        history.push('/review')
    };

    const handleSaveConsentModal = () => {
        console.log('Consent Saved');
        // Implement save logic here...
        handleCloseConsentModal(); // Close modal after save
    };

    // Calculate progress percentage
    const progress = (activeStep / (steps.length - 1)) * 100;

    const getTextForHolder = (holder) => {
        if (holder == 2) {
            return '2nd'
        } else {
            return '3rd'
        }
    }

    return (
        <div>
            <div className='text-muted text-sm'>Add Joint Holder ({getTextForHolder(activeHolder)} Holder)</div>
            <div>{steps[activeStep].component}</div>
            {/* Navigation buttons Activate these button for development purpose only*/}
            {/* <div>
                {steps[activeStep].showBackButton && (
                    <Button onClick={handleBack}>
                        Back
                    </Button>
                )}
                <Button onClick={handleNext}>
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                </Button>
            </div> */}
            <Modal show={showAddMoreModal} onHide={() => {
                setShowAdddMoreModal(false);
                // dispatch(updateJointholderFlowScreen(false))
                setShowConsentModal(true)
            }} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Jointholder</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want to add 3rd joint holder for demat account?</p>
                    <p>Please ensure you have the following details ready for the joint holder:</p>
                    <ul>
                        <li>PAN details</li>
                        <li>Proof of address (such as Aadhaar, Driving License, Voter ID, or Passport) For KRA compliance</li>
                        <li>Scanned signature</li>
                        <li>Visual verification of the joint holder</li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button title='No' handleClick={() => {
                        setShowAdddMoreModal(false)
                        // dispatch(updateJointholderFlowScreen(false))
                        setShowConsentModal(true)
                        setShowHolder(2)
                    }} />
                    <Button title='Yes' handleClick={() => {
                        setShowAdddMoreModal(false)
                        submitToApi(true, 3)
                        setShowHolder(3)
                    }} />
                </Modal.Footer>
            </Modal>
            {/* Modal for Consent */}
            <ConsentModal
                showModal={showConsentModal}
                handleClose={handleCloseConsentModal}
                handleSave={handleSaveConsentModal}
                showHolder={showHolder}
            />
        </div>
    );
}

export default JointHolder;
